import { Reducer } from 'redux';
import { UserTask } from "models/UserTask";
import { IUserTaskActions, UserTaskActionType } from "redux/actions/UserTaskActions";

const initialState: UserTask[] | null = null;
export const userTasksReducer: Reducer<UserTask[] | null, IUserTaskActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case UserTaskActionType.FETCH_USERTASKS_SUCCESS:
                {
                    return action.returnPayload as UserTask[];
                }
            case UserTaskActionType.ADD_USERTASK_SUCCESS:
                {
                    if (!state) return state; // tasks not fetched yet, SignalR updates still arrive
                    let newUserTasks = [...state!];
                    newUserTasks.push({ ...action.returnPayload } as UserTask)
                    return newUserTasks;
                }
            case UserTaskActionType.EDIT_USERTASK_SUCCESS:
            case UserTaskActionType.DELETE_USERTASK_SUCCESS:
                {
                    if (!state) return state;
                    let newUserTasks = [...state!];
                    const updatedUserTask = { ...action.returnPayload } as UserTask;
                    newUserTasks = newUserTasks.map(nm => nm.id === updatedUserTask.id ? updatedUserTask : nm);
                    return newUserTasks;
                }
            default:
                return state;
        }
    };
